import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      [theme.breakpoints.up('xs')]: {
        width: '100%',
      },
      [theme.breakpoints.up('md')]: {
        width: '100%',
      },
      [theme.breakpoints.up('lg')]: {
        width: '100%',
      },
    },
    input: {
      marginLeft: theme.spacing(1),
      width: '100%',
    },
    iconButton: {
      padding: 10,
    },
    divider: {
      height: 28,
      margin: 4,
    },
    btnPrimary: {
      minHeight: 38,
      height: 38,
      width: 38,
      minWidth: 38,
      textTransform: 'none',
      background:
        'transparent linear-gradient(230deg, #FFDC27 0%, #E63C3C 50%, #000A8C 100%) 0% 0% no-repeat padding-box',
      color: '#fff',
      '@media(min-width: 1250px)': {
        minHeight: 48,
        height: 48,
        width: 146,
        minWidth: 146,
      },
    },
    paddingY: {
      paddingTop: 50,
      paddingBottom: 50,
      width: '100%',
      margin: '0 auto',
    },
    flexCenterY: {
      display: 'flex',
      alignItems: 'center',
    },
    bodycenter: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
    },
    sousTitre: {
      color: 'black !important',
      fontSize: '19px',
    },
  }),
);

export default useStyles;
